import { ScrollingModule } from "@angular/cdk/scrolling";
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MaterialModule } from "@app/material.module";
import { TimeInputModule } from "@app/shared/time-input/time-input.module";
import { SatPopoverModule } from "@ncstate/sat-popover";
import { TranslateModule } from "@ngx-translate/core";
import { DurationInputControlModule } from "../duration-input-control/duration-input-control.module";
import { AuditFilterPopoverComponent } from "./audit-filter-popover.component";

@NgModule({
	declarations: [AuditFilterPopoverComponent],
	imports: [
		CommonModule,
		SatPopoverModule,
		MaterialModule,
		FormsModule,
		ReactiveFormsModule,

		ScrollingModule,
		TranslateModule,
		TimeInputModule,
		DurationInputControlModule,
	],
	exports: [AuditFilterPopoverComponent],
})
export class AuditFilterPopoverModule {}
